import { useEffect, useState } from 'react'
import api from '../services/api'

// Parâmetros gerais do sistema — equivalente à TSILVER do ERP (frota.veiver, registro único).
interface Parametros {
  vercod: string; vernro: number; verdat: string; versen: string; verfil: number; veremp: number
}

const inp: React.CSSProperties = {
  border: '1px solid #d1d5db', borderRadius: 4, padding: '4px 8px',
  fontSize: '0.85rem', height: 32, background: '#fff', width: '100%', boxSizing: 'border-box',
}
const label: React.CSSProperties = { fontSize: '0.72rem', color: '#6b7280', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.03em' }

function Campo({ rotulo, width, children }: { rotulo: string; width: number; children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 3, width }}>
      <label style={label}>{rotulo}</label>
      {children}
    </div>
  )
}

const soNumero = (v: string) => v.replace(/\D/g, '').slice(0, 5)

export default function ParametrosSistema() {
  const [original, setOriginal] = useState<Parametros | null>(null)
  const [form, setForm] = useState({ vernro: '', verdat: '', versen: '', verfil: '', veremp: '' })
  const [carregando, setCarregando] = useState(true)
  const [salvando, setSalvando] = useState(false)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState('')

  function preencher(p: Parametros) {
    setOriginal(p)
    setForm({ vernro: String(p.vernro ?? ''), verdat: p.verdat || '', versen: p.versen || '', verfil: String(p.verfil ?? ''), veremp: String(p.veremp ?? '') })
  }

  useEffect(() => {
    api.get('/erp/parametros-sistema')
      .then(r => preencher(r.data))
      .catch(e => setErro(e?.response?.data?.error || 'Erro ao carregar os parâmetros.'))
      .finally(() => setCarregando(false))
  }, [])

  const alterado = !!original && (
    form.vernro !== String(original.vernro) || form.verdat !== original.verdat || form.versen !== original.versen ||
    form.verfil !== String(original.verfil) || form.veremp !== String(original.veremp))

  async function salvar() {
    if (!original) return
    setErro(''); setSucesso('')
    if (!form.vernro || !form.verfil || !form.veremp || !form.verdat) { setErro('Preencha Nº Veículos, Data, N.Filial e N.Empresa.'); return }
    setSalvando(true)
    try {
      await api.put(`/erp/parametros-sistema/${encodeURIComponent(original.vercod)}`, {
        vernro: Number(form.vernro), verdat: form.verdat, versen: form.versen, verfil: Number(form.verfil), veremp: Number(form.veremp),
      })
      const r = await api.get('/erp/parametros-sistema')
      preencher(r.data)
      setSucesso('Parâmetros salvos.')
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar os parâmetros.')
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div>
      <h2 style={{ fontSize: '1.1rem', fontWeight: 700, margin: '0 0 0.75rem' }}>Parâmetros</h2>

      {erro && <div className="alert alert-danger" style={{ marginBottom: '0.75rem' }}>{erro}</div>}
      {sucesso && <div className="alert alert-success" style={{ marginBottom: '0.75rem' }}>✓ {sucesso}</div>}

      {carregando ? (
        <div style={{ color: '#6b7280', fontSize: '0.85rem' }}>Carregando...</div>
      ) : original && (
        <div style={{
          background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, maxWidth: 520,
          boxShadow: '0 1px 4px rgba(0,0,0,0.07)', padding: '1rem 1.1rem',
        }}>
          <div style={{ display: 'flex', gap: '0.9rem 1.5rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
            <Campo rotulo="Código" width={120}>
              <input style={{ ...inp, background: '#f3f4f6' }} value={original.vercod} readOnly disabled />
            </Campo>
            <Campo rotulo="Nº Veículos" width={120}>
              <input style={inp} inputMode="numeric" value={form.vernro} onChange={e => setForm(f => ({ ...f, vernro: soNumero(e.target.value) }))} />
            </Campo>
            <div style={{ width: '100%' }} />
            <Campo rotulo="Data" width={150}>
              <input style={inp} type="date" value={form.verdat} onChange={e => setForm(f => ({ ...f, verdat: e.target.value }))} />
            </Campo>
            <Campo rotulo="Senha" width={120}>
              <input style={inp} maxLength={6} value={form.versen} onChange={e => setForm(f => ({ ...f, versen: e.target.value }))} />
            </Campo>
            <div style={{ width: '100%' }} />
            <Campo rotulo="N.Filial" width={90}>
              <input style={inp} inputMode="numeric" value={form.verfil} onChange={e => setForm(f => ({ ...f, verfil: soNumero(e.target.value) }))} />
            </Campo>
            <Campo rotulo="N.Empresa" width={90}>
              <input style={inp} inputMode="numeric" value={form.veremp} onChange={e => setForm(f => ({ ...f, veremp: soNumero(e.target.value) }))} />
            </Campo>
          </div>
          <div style={{ display: 'flex', gap: '0.6rem' }}>
            <button className="btn btn-primary btn-sm" disabled={salvando || !alterado} onClick={salvar}>
              {salvando ? 'Salvando...' : 'Salvar'}
            </button>
            <button className="btn btn-secondary btn-sm" disabled={salvando || !alterado} onClick={() => { preencher(original); setErro(''); setSucesso('') }}>
              Desfazer
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
